/**
 * Parse / validate helpers for level JSON.
 */
import { LevelDefSchema, GateDefSchema, EnemyWaveDefSchema, PedestalDefSchema, } from "./schemas.js";
function formatIssues(issues) {
    return issues.map((i) => ({
        path: i.path.map(String).join(".") || "(root)",
        message: i.message,
    }));
}
/** Safe-parse unknown JSON into a LevelDef. */
export function parseLevel(input) {
    const result = LevelDefSchema.safeParse(input);
    if (result.success) {
        return { success: true, data: result.data };
    }
    const issues = formatIssues(result.error.issues);
    return {
        success: false,
        error: issues.map((i) => `${i.path}: ${i.message}`).join("; "),
        issues,
    };
}
/**
 * Parse or throw — for loaders that prefer exceptions.
 * @throws Error with readable multi-issue message
 */
export function parseLevelOrThrow(input) {
    const result = parseLevel(input);
    if (!result.success) {
        throw new Error(`Invalid level: ${result.error}`);
    }
    return result.data;
}
/** Validate a gate in isolation (authoring tools / unit tests). */
export function parseGate(input) {
    const result = GateDefSchema.safeParse(input);
    if (result.success)
        return { success: true, data: result.data };
    const issues = formatIssues(result.error.issues);
    return {
        success: false,
        error: issues.map((i) => `${i.path}: ${i.message}`).join("; "),
        issues,
    };
}
/** Validate an enemy wave in isolation. */
export function parseWave(input) {
    const result = EnemyWaveDefSchema.safeParse(input);
    if (result.success)
        return { success: true, data: result.data };
    const issues = formatIssues(result.error.issues);
    return {
        success: false,
        error: issues.map((i) => `${i.path}: ${i.message}`).join("; "),
        issues,
    };
}
/** Validate a pedestal in isolation. */
export function parsePedestal(input) {
    const result = PedestalDefSchema.safeParse(input);
    if (result.success)
        return { success: true, data: result.data };
    const issues = formatIssues(result.error.issues);
    return {
        success: false,
        error: issues.map((i) => `${i.path}: ${i.message}`).join("; "),
        issues,
    };
}
/**
 * Strip optional schemaVersion and return a plain object suitable for
 * `@afr/sim` createRun({ level }) — sim ignores unknown fields but we
 * pass a clean structural LevelDef.
 */
export function toSimLevel(level) {
    const { schemaVersion: _sv, ...rest } = level;
    return rest;
}
//# sourceMappingURL=parse.js.map